export default __webpack_public_path__ + "static/media/not-optimal-solution.b2562377.svg";